import { ApiError } from '@clockwise/shared';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ImportSheet } from '@/components/custom/import-sheet';
import { productsApi } from '@/lib/api';
import { triggerDownload } from '@/lib/download';
import { queryKeys } from '@/lib/query-keys';

interface ProductImportSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProductImportSheet({ open, onOpenChange }: ProductImportSheetProps) {
  const queryClient = useQueryClient();

  return (
    <ImportSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Import activities"
      description="Upload an .xlsx or .csv."
      onImport={async (file, { idempotencyKey }) => {
        const res = await productsApi.importFile(file, { idempotencyKey });
        return {
          totalRows: res.data.totalRows,
          created: res.data.created,
          updated: res.data.updated,
          failed: res.data.failed,
          rows: res.data.rows.map((r) => ({
            rowNumber: r.rowNumber,
            outcome: r.outcome,
            errors: r.errors,
          })),
        };
      }}
      onSuccess={() => {
        queryClient.invalidateQueries({ queryKey: queryKeys.products.all });
      }}
      onDownloadTemplate={async () => {
        try {
          const { blob, filename } = await productsApi.exportTemplate();
          triggerDownload(blob, filename ?? 'activities-template.xlsx');
        } catch (err) {
          const msg = err instanceof ApiError ? err.message : 'Template download failed';
          toast.error(msg);
        }
      }}
    />
  );
}
